import orgSelectedEventHandler from './handlers/org.selected.handler';
import logoutEventHandler from './handlers/logout.handler';

class EventHandlersRegister {
  public static register() {
    orgSelectedEventHandler.register();
    logoutEventHandler.register();
  }
  public static unRegister() {
    orgSelectedEventHandler.unRegister();
    logoutEventHandler.unRegister();
  }
}
export default EventHandlersRegister;
